import React, { useEffect } from 'react'
import * as R from 'ramda'

// import { useFetcher } from 'libs/fetcher';

import Filter from '../Filter'
import { BarChart } from './BarChart'
import { LineChart } from './LineChart'
import useUsageSummary from './useUsageSummary'
import { UsagePercentage } from './UsagePercentage'

export function Panel() {
  const {
    state: { planBill, accumulate, lineData, filter, dateRang, isLoading },
    handleSelectedFilter,
    handleFirstMount,
    handleSelectedDate,
  } = useUsageSummary()

  const firstMount = () => {
    handleFirstMount()
  }

  useEffect(firstMount, [])

  return (
    <>
      <Filter
        onSelectedDate={handleSelectedDate}
        dateRang={dateRang}
        defaultFilter={filter}
        isLoading={isLoading}
        onSelectedFilter={(values) => handleSelectedFilter(values)}
      />
      <div className="w-full">
        <LineChart lineData={lineData} />
      </div>
      <div className="w-full md:flex md:justify-between space-y-5 md:space-y-0">
        <div className="w-full md:w-4/6 md:mr-5 ">
          <BarChart
            accumulate={accumulate}
            beacon={R.path(['balance', 'totalBeacon'], planBill)}
          />
        </div>
        <div className="w-full md:w-2/6 md:ml-5 ">
          <UsagePercentage
            accumulate={accumulate}
            beacon={R.path(['balance', 'totalBeacon'], planBill)}
          />
        </div>
      </div>
    </>
  )
}
